<div class="container-fluid login">
    <div class="login-background"></div>
    <div class="login-background-overlay"></div>
    <div class="row login-logo">
        <div class="col-12 m-auto h-100 text-center">
            <img
                class="mh-100 mw-100"
                src="assets/compas_lato_white.svg"
                alt
                role="presentation"
            />
        </div>
    </div>
    <cmps-client-logo [login]="true"></cmps-client-logo>
    <div class="row form">
        <div class="col-12 m-auto">
            <div class="card">
                <div cmpsI18nSwitcher></div>
                <div class="card-body">
                    <cmps-wait-status *ngIf="hasPendingData"></cmps-wait-status>
                    <ng-container *ngIf="!hasPendingData && !validToken">
                        <div class="text-center h5 text-white">
                            {{
                                i18n._95_PASSWORD_RESET | translate | uppercase
                            }}
                        </div>
                        {{ serverError | translate }}
                    </ng-container>
                    <ng-container *ngIf="!hasPendingData && validToken">
                        <div class="text-center h5 text-white">
                            {{
                                i18n._95_PASSWORD_RESET | translate | uppercase
                            }}
                        </div>
                        <p>
                            {{
                                i18n._946_PLEASE_CHANGE_YOUR_PASSWORD_BELOW_
                                    | translate
                            }}
                        </p>
                        <div class="container-fluid pr-0 pl-0">
                            <form
                                [name]="form.name"
                                #ngForm="ngForm"
                            >
                                <ng-container *ngIf="!success">
                                    <div class="row">
                                        <div class="col-12 form-group">
                                            <label
                                                [for]="
                                                    form.fields.NEW_PASSWORD.id
                                                "
                                                >{{
                                                    form.fields.NEW_PASSWORD
                                                        .label | translate
                                                }}</label
                                            >
                                            <input
                                                type="password"
                                                class="form-control"
                                                autocomplete="new-password"
                                                [name]="
                                                    form.fields.NEW_PASSWORD
                                                        .name
                                                "
                                                [placeholder]="
                                                    form.fields.NEW_PASSWORD
                                                        .placeholder | translate
                                                "
                                                [disabled]="form.submitted"
                                                [(ngModel)]="
                                                    resetPasswordModel.password
                                                "
                                                [field]="
                                                    form.fields.NEW_PASSWORD
                                                "
                                            />
                                            <div
                                                class="alert alert-warning mt-1 mb-0"
                                                role="alert"
                                                *ngIf="form.errors.NEW_PASSWORD"
                                            >
                                                {{ form.errors.NEW_PASSWORD }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 form-group">
                                            <label
                                                [for]="
                                                    form.fields
                                                        .NEW_PASSWORD_CONFIRM.id
                                                "
                                                >{{
                                                    form.fields
                                                        .NEW_PASSWORD_CONFIRM
                                                        .label | translate
                                                }}</label
                                            >
                                            <input
                                                type="password"
                                                class="form-control"
                                                autocomplete="new-password"
                                                [name]="
                                                    form.fields
                                                        .NEW_PASSWORD_CONFIRM
                                                        .name
                                                "
                                                [placeholder]="
                                                    form.fields
                                                        .NEW_PASSWORD_CONFIRM
                                                        .placeholder | translate
                                                "
                                                [disabled]="form.submitted"
                                                [(ngModel)]="
                                                    resetPasswordModel.passwordConfirm
                                                "
                                                [requiredWhenValidator]="
                                                    form.fields.NEW_PASSWORD.id
                                                "
                                                [markAsRequired]="true"
                                                [textEqualValidator]="
                                                    form.fields.NEW_PASSWORD.id
                                                "
                                                [field]="
                                                    form.fields
                                                        .NEW_PASSWORD_CONFIRM
                                                "
                                            />
                                            <div
                                                class="alert alert-warning mt-1 mb-0"
                                                role="alert"
                                                *ngIf="
                                                    form.errors
                                                        .NEW_PASSWORD_CONFIRM
                                                "
                                            >
                                                {{
                                                    form.errors
                                                        .NEW_PASSWORD_CONFIRM
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                <div class="row">
                                    <div class="col-12">
                                        <div
                                            class="alert alert-info"
                                            role="alert"
                                            *ngIf="form.submitted"
                                        >
                                            {{
                                                i18n._928_PLEASE_WAIT_
                                                    | translate
                                            }}
                                        </div>
                                        <div
                                            class="alert alert-warning"
                                            role="alert"
                                            *ngIf="failure"
                                        >
                                            {{ form.serverError | translate }}
                                        </div>
                                        <div
                                            class="alert alert-success"
                                            role="alert"
                                            *ngIf="success"
                                        >
                                            {{
                                                i18n._871_THE_PASSWORD_HAS_BEEN_SUCCESSFULLY_CHANGED_
                                                    | translate
                                            }}
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="float-right">
                                            <ng-container
                                                *ngIf="
                                                    !success;
                                                    else successTpl
                                                "
                                            >
                                                <button
                                                    type="button"
                                                    class="btn btn-secondary mr-2"
                                                    [routerLink]="'login'"
                                                >
                                                    {{
                                                        i18n._121_CANCEL
                                                            | translate
                                                    }}
                                                </button>
                                                <button
                                                    type="submit"
                                                    class="btn btn-primary"
                                                    (click)="onSubmit()"
                                                    [disabled]="form.submitted"
                                                >
                                                    {{
                                                        i18n._111_CHANGE_PASSWORD
                                                            | translate
                                                    }}
                                                </button>
                                            </ng-container>
                                            <ng-template #successTpl>
                                                <button
                                                    type="button"
                                                    class="btn btn-primary"
                                                    [routerLink]="'login'"
                                                >
                                                    {{
                                                        i18n._130_LOGIN
                                                            | translate
                                                    }}
                                                </button>
                                            </ng-template>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
